export const CHECK_API = 'checkApi';
export const VERSION_APP_UNSUPPORTED = '9.9.9';
// 方法常量
/**
 * 公共
 */
export const API_GET_CLIENT_INFO = 'getClientInfo';
export const API_GET_COMMON_INFO = 'getCommonInfo';
export const API_SHOW_LOADING = 'showLoadingStatus';
export const API_HIDE_LOADING = 'hideLoadingStatus';
export const API_GET_USER_CONSENT = 'getUserConsent';
/**
 * 支付
 */
export const API_GET_ORDER_INFO = 'getOrderInfo';
export const API_SHOW_THIRD_PAY_LOADING = 'loadingThirdPay';
export const API_NOTIFY_PAY_SUCCESS = 'showPaySuccessPage';
export const API_NOTIFY_PAY_PENDING = 'showPayPendingPage';
export const API_NOTIFY_PAY_FAILED = 'showPayFailPage';
export const API_NOTIFY_PAY_START = 'tradeVoghionPayHandle';
export const API_GET_PAYPAL_MAGNES_RESULT = 'getPaypalMagnesResult';
export const API_CHECK_APPLE_PAY = 'getApplePayDisabled';
export const API_CHECK_GOOGLE_PAY = 'getGooglePayDisabled';
export const API_REQUEST_APPLE_PAY = 'onClickApplePay';
export const API_REQUEST_GOOGLE_PAY = 'onClickGooglePay';
/**
 * 路由
 */
export const API_NAVIGATE_TO = 'navigateTo';
export const API_REDIRECT_TO = 'redirectTo';
export const API_NAVIGATE_BACK = 'navigateBack';
export const API_LAUNCH_TRUSTED_WEB_BROWSER = 'launchTrustedWebBrowser';
export const API_NAVIGATE_TO_CART = 'navigateToCart';
/**
 * 开放接口
 */
export const API_LOGIN = 'login';
export const API_LOG_AF_EVENT = 'logAFEvent';
export const API_OPEN_CUSTOMER_SERVICE_CHAT = 'openCustomerServiceChat';
export const API_UPDATE_MESSAGE_UNREAD_COUNT = 'updateMessageUnreadCount';
export const API_DETECT_HYBRID_SERVER = 'detectHybridServer';
export const API_GET_SYSTEM_SETTING = 'getSystemSetting';
export const API_OPEN_SYSTEM_SETTING = 'openSystemSetting';
export const API_LOG_GA_EVENT = 'logGAEvent';
export const API_UPDATE_LOGIN_USER = 'updateLoginUser';
/**
 * 缓存
 */
export const API_SET_CACHE = 'setCache';
export const API_GET_CACHE = 'getCache';
/**
 * 控制台
 */
export const API_CONSOLE = 'console';
/**
 * 页面
 */
export const API_SET_NAVIGATION_BAR = 'setNavigationBar';
export const API_SET_STATUS_BAR_STYLE = 'setStatusBarStyle';
export const API_SWITCH_POP_GESTURE = 'switchPopGesture';
export const API_CUSTOM_BACK = 'customBack'; // 自定义返回
/**
 * 商品
 */
export const API_SHOW_SKU_SELECTOR_MODAL = 'showSkuSelectorModal';
/**
 * 事件
 */
export const EVENT_BACK_INVOKED = 'backInvoked'; // 客户端触发返回
export const EVENT_BACK_TO_TOP = 'backToTop'; // 返回顶部
export const EVENT_VENDOR_CALLBACK = 'vendorCallback'; // 第三方回调
export const EVENT_APP_SHOW = 'appShow'; // app 显示（切回前台）
export const EVENT_APP_HIDE = 'appHide'; // app 隐藏（切到后台）
export const EVENT_MAGIC = 'magic'; // 魔术事件，注册后支持捕获所有未注册的事件
export const EVENT_CHECK_HYBRID_SERVER = 'checkHybridServer'; // 检测 hybrid server 是否存在
export const EVENT_HYBRID_SERVER_READY = 'hybridServerReady'; // hybrid server 已就绪
export const EVENT_APPLE_PAY_RESULT = 'getApplePayQueryResult'; // apple pay 结果
export const EVENT_GOOGLE_PAY_RESULT = 'getGooglePayQueryResult'; // google pay 结果
export const EVENT_KEYBOARD_RECT_CHANGE = 'keyboardRectChange'; // 键盘尺寸变化事件
export const EVENT_CUSTOM = 'custom'; // 自定义事件，主要用于微前端环境定义在 app 中不适配的事件
/**
 * 响应码，参考 android 定义
 */
export var ResponseCode;
(function (ResponseCode) {
    /**
     * 取消
     */
    ResponseCode[ResponseCode["Cancelled"] = 0] = "Cancelled";
    /**
     * 成功
     */
    ResponseCode[ResponseCode["OK"] = 1] = "OK";
    /**
     * 失败
     */
    ResponseCode[ResponseCode["Error"] = -1] = "Error";
})(ResponseCode || (ResponseCode = {}));
/**
 * 购物车
 */
export const API_SET_CART_FAB = 'setCartFab';
/**
 * 授权
 */
export const API_AUTHORIZE = 'authorize';
/** 获取授权结果 */
export const API_GET_AUTH = 'getAuth';
/**
 * 键盘
 */
export const API_CUSTOM_KEYBOARD_EVENT = 'customKeyboardEvent';
